import {createAction} from 'redux-actions';
import {FETCH_CONFIG_SYSTEM, UPDATE_CONFIG_SYSTEM} from './constants';

export const fetchConfigSystem = createAction(FETCH_CONFIG_SYSTEM.REQUEST, (params)=> ({params}));
export const updateConfigSystem = createAction(UPDATE_CONFIG_SYSTEM.REQUEST, (params)=> ({params}));
